module.exports = __webpack_public_path__ + "static/media/countdown-5.aa9b79de.mp3";